import { Injectable } from '@angular/core';
import { CustomOrderEntry, CustomOrderEntryWithDelivery, DeliveryType, DeliveryTypeEnum } from '@cart/const';
import { CustomOrder } from '@order/const';
import { OrderService } from '@order/feature';
import { BehaviorSubject, map, Observable, ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class OrderDetailsComponentService {
  orderEntries$: Observable<CustomOrderEntry[] | undefined> = this.getOrderDetails().pipe(
    map((order: CustomOrder) => order.entries as CustomOrderEntry[]),
  );

  private showDeliverySwitch$ = new BehaviorSubject<boolean>(false);
  private isDeliveryFilter$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private orderService: OrderService) {}

  getOrderDetails(): Observable<CustomOrder> {
    return this.orderService.getOrderDetails().pipe(filter(Boolean));
  }

  setDeliveryFilter(isDeliveryFilter: boolean): void {
    this.isDeliveryFilter$.next(isDeliveryFilter);
  }

  getDeliveryFilter(): ReplaySubject<boolean> {
    return this.isDeliveryFilter$;
  }

  setShowDeliverySwitch(showDeliverySwitch: boolean): void {
    this.showDeliverySwitch$.next(showDeliverySwitch);
  }

  getShowDeliverySwitch(): BehaviorSubject<boolean> {
    return this.showDeliverySwitch$;
  }

  mapOrderEntriesToGroups(entries: CustomOrderEntry[]): CustomOrderEntryWithDelivery[] {
    return entries.reduce((groupedEntries: CustomOrderEntryWithDelivery[], entry: CustomOrderEntry) => {
      const deliveryType: DeliveryType = entry.delivery
        ? { type: DeliveryTypeEnum.Delivery, delivery: entry.delivery }
        : { type: DeliveryTypeEnum.Pickup, pickup: entry.pickup };

      const entryIndex = groupedEntries.findIndex(
        (groupEntry) =>
          (deliveryType.type === DeliveryTypeEnum.Delivery &&
            groupEntry.deliveryType.delivery?.address === entry.delivery?.address) ||
          (deliveryType.type === DeliveryTypeEnum.Pickup &&
            groupEntry.deliveryType.pickup?.warehouseCode === entry.pickup?.warehouseCode),
      );

      if (entryIndex === -1) {
        groupedEntries.push({ deliveryType, entry: [entry] });
      } else {
        groupedEntries[entryIndex].entry.push(entry);
      }

      return groupedEntries;
    }, []);
  }
}
